import { Component, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ErrorDialogService as NewErrorDialogService } from '@app/services/error-dialog.service';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { NavigationService } from '@app/services/navigation.service';
import { EnterYourInformationComponent } from 'app-classic/components/booking-steps/enter-your-information/enter-your-information.component';
import { ContentService } from 'app-classic/services/content.service';
import { ErrorDialogService } from 'app-classic/services/error-dialog.service';
import { UserAccountService } from 'app-classic/services/user-account.service';
import { CreateAccountFormComponent as NewCreateAccountFormComponent } from '../../../../app/components/user-accounts/create-account-form/create-account-form.component';

@Component({
    selector: 'app-create-account-form',
    templateUrl: './create-account-form.component.html',
    styleUrls: ['./create-account-form.component.scss'],
    standalone: false,
})
export class CreateAccountFormComponent extends NewCreateAccountFormComponent {
    @ViewChild(EnterYourInformationComponent) _enterYourInformationComponent: EnterYourInformationComponent | undefined;

    constructor(
        private bottomSheet: MatBottomSheet,
        private _localStorageService: LocalStorageService,
        private _router: Router,
        private _contentService: ContentService,
        private _userAccountService: UserAccountService,
        private _errorDialogService: ErrorDialogService,
        private _featureFlagService: FeatureFlagService,
        private _newErrorDialogService: NewErrorDialogService,
        private _navigationService: NavigationService
    ) {
        super(
            _localStorageService,
            _router,
            _contentService,
            _userAccountService,
            _newErrorDialogService,
            _featureFlagService,
            _navigationService
        );
    }

    public closeBottomSheet(): void {
        this.bottomSheet.dismiss();
    }

    protected getEnterYourInformationComponent(): EnterYourInformationComponent | undefined {
        return this._enterYourInformationComponent;
    }

    protected openErrorDialog(message: string) {
        this._errorDialogService.openErrorDialog(message);
    }
}
